import * as React from 'react';
export const IcTabManager = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3z'
      fill='currentColor'
    />
    <path
      d='M12.643 16h-1.356V9.16c-.272.144-.608.3-1.008.468a7.032 7.032 0 01-.96.348V8.788c.296-.096.676-.252 1.14-.468.464-.216.848-.42 1.152-.612h1.032V16z'
      fill='#fff'
    />
  </svg>
);
